import React from 'react';
import { useLocation } from '@remix-run/react';

import Icon from '~/components/icon';
import { type MobileBottomNavItem } from '~/interfaces/HeaderFooterNavV2';
import { useServicesContext } from '~/providers/services-context';

import styles from '../../MobileBottomNav.module.css';
import { handleEvent } from '../../utils/handleEvent';

interface NavLinkProps {
  item: MobileBottomNavItem;
}

export const NavLink = ({ item }: NavLinkProps) => {
  const location = useLocation();
  const { trackingActions } = useServicesContext();
  const [icon, dimension = '20'] = (item.icon || '').split(',');
  const isSelected = item.link === location.pathname;

  return (
    <li
      aria-label={item.name}
      className={`${styles.menuItem} ${isSelected ? styles.active : ''}`}
      data-testid="mobile-bottom-nav-item"
      onClick={() => handleEvent(item.name, trackingActions)}>

			<a href={item.link}>
				{icon &&
        <span className={styles.iconContainer}>
						<Icon
            height={parseInt(dimension, 10)}
            icon={icon}
            width={parseInt(dimension, 10)} />

						{item.count ?
          <span className={styles.offerCount}>{item.count}</span> :
          null}
					</span>
        }
				{item.name}
			</a>
		</li>);

};